<template>
  <div class="special-main">

    <div class="pt-e-detail">

<!--      <div style="position: absolute;width: 100%;left: 0;top: 0;opacity: 0.7;z-index: 99999;">-->
<!--        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/0555e53ea236649ffd2221e5b296087b.jpg" alt="">-->
<!--      </div>-->

      <div class="pt-e-banner">
        <div class="pt-e-banner-txt">
          <div class="p-title">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260701/592045dcfd2efe89cff733a1cd95561e.png" alt="">
          </div>
          <p>Dental Scaler and Air Polisher</p>
        </div>
        <div class="pt-e-banner-img">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260701/e3ed3305fdee4c5f49db013a3db497f2.jpg" alt="">
        </div>
      </div>

      <div class="promotional-cover" v-observe-visibility="(isVisible) => handleVisibility(isVisible, 0)">
        <div class="progress">
          <circular-progress :progress="videoList[0].progress" :isPlaying="videoList[0].playing" index="0" @togglePlay="togglePlay"/>
        </div>
        <div class="mask">
          <div class="content">
            <h3>New Experience of</h3>
            <h3>Comfort and Efficiency</h3>
            <div class="button">
              <view-button @onclick="openVideoModal(videoList[0].previewVideo)"></view-button>
            </div>
          </div>
        </div>
        <video class="background-video"
               :ref="videoList[0].ref"
               :src="videoList[0].video"
               muted
               playsinline
               loop
        ></video>
      </div>

      <div class="power-container">
        <h3 class="tit">POWER MEETS COMFORT</h3>
        <h4>New Airstream Nozzle Design</h4>
        <p class="desc">A new petal-shaped nozzle delivers a more focused water mist, </p>
        <p class="desc">balancing efficiency with patient comfort. Cleaning efficiency increased</p>
        <p class="num">35%</p>
        
        <div class="model">
          <p class="model-tit previous">Previous Model</p>
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260703/2f5b5807fd06a8bb66ede4c0c9db2e2f.png" alt="">
          <p class="model-tit new">New Model</p>
        </div>
      </div>

      <div class="feature-container">
        <div class="feature-bg">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260703/0c3c75dfb26c805924fe287f8d4c38b2.jpg" alt="" />
        </div>
        <div class="feature-content">
          <p>Low-noise airstream:</p>
          <p>75.8dB in commonly used settings,</p>
          <p>9dB quieter for a calmer experience</p>

          <p class="mt-44">Less impact (g):</p>
          <p class="font-size-64 line-height-16">28.7%</p>
          <p class="line-height-14">Lower water and air impact at the same efficiency,<br/>ensuring greater patient comfort</p>
          <div class="params pt-e-c">
            <div class="pt-e">
              <p>Power level 6</p>
              <p>6.68g</p>
            </div>
            <p class="tit">PT-E</p>
          </div>
          <div class="params Standard-c">
            <div class="Standard">
              <p>Power level 6</p>
              <p>9.37g</p>
            </div>
            <p class="tit">Standard</p>
          </div>
        </div>
      </div>

      <div class="heating-system-container">
        <h4>Dual Heating System</h4>
        <p class="desc">Deliver warm water for both ultrasonic and airstream functions</p>
        <p class="desc line-height-14">4 temperature settings:</p>
        <p class="desc">25°C, 30°C, 35°C, 40°C for airstream，24°C, 28°C, 32°C, 36°C for scaling</p>
        <p class="desc">350W heating power: increased by 16.67%</p>
        <div class="heating-system-img">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/069a071925b9352562355c1021e54b36.jpg" alt="">
        </div>
        <div class="upgraded">
          <div class="img">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/589b2e2122f7407ceecfde5336e898ab.jpg" alt="">
          </div>
          <div class="txt">
            <h4>Upgraded Airstream</h4>
            <h4>Handpiece with LED</h4>
            <p class="desc">Inbuilt LED light improves visibility<br>and enhances operational precision<br>for better treatment outcomes. </p>
          </div>
        </div>
        <div class="titanium-alloy">
          <div class="txt">
            <h4>Titanium Alloy Handpiece</h4>
            <p class="desc">Crafted with high-strength titanium alloy，offering superior biocompatibility, <br/>greater corrosion resistance, and enhanced wear resistance.</p>
          </div>
          <div class="img">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/12c169213d07fc654136da032bfbfc7d.png" alt="">
          </div>
        </div>
      </div>

      <div class="precision-container">
        <h3 class="tit">VERSATILITY MEETS PRECISION</h3>
        <h4>Six Ultrasonic Modes</h4>
        <p class="desc">Designed to meet different needs.</p>
        
        <div class="step-use">
          <div class="step-item">
            <h5 class="letter">G</h5>
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/b31b2dbb1bee18128e453e876999bb55.png" alt="">
            <div class="explain-c">
              <div class="explain-b">
                <div>
                  <p class="explain-tit">Ultra scaling</p>
                  <p>For rapid and efficient<br/>removal of large<br/>calculus,reducing<br/>procedure time</p>
                </div>
                <div>
                  <p class="explain-tit">Soft scaling</p>
                  <p>For gentle removal<br/>of stains and soft<br/>deposits, minimizing<br/>patient discomfort</p>
                </div>
              </div>
            </div>
          </div>
          <div class="step-item">
            <h5 class="letter">P</h5>
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/ea7ea7da81d1045a2cf6d71d61e8b936.png" alt="">
            <div class="explain-c">
              <div class="explain-b">
                <div>
                  <p class="explain-tit">Perio</p>
                  <p>For effective biofilm<br/>removal,protecting<br/>soft tissue and<br/>minimizing trauma</p>
                </div>
                <div>
                  <p class="explain-tit">Implant<br/>maintenance</p>
                  <p>Six adjustable levels<br/>for precise and<br/>safe implant<br/>surface cleaning</p>
                </div>
              </div>
            </div>
          </div>
          <div class="step-item">
            <h5 class="letter">E</h5>
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/f2ece65b023f4d59329bc016b35650cd.png" alt="">
            <div class="explain-c">
              <div class="explain-b">
                <div>
                  <p class="explain-tit">Endo</p>
                  <p>Precise ultrasonic<br/>power optimizes root <br/>canal preparation and<br/>enhances treatment success</p>
                </div>
                <div>
                  <p class="explain-tit">Irrigation</p>
                  <p>Six safety levels<br/>ensure effective<br/>debris removal<br/>whileprotecting dentin</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="scaling">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/637a4c4cf9fed37070b92d844b82f76c.png" alt="">
        </div>
      </div>
      
      <div class="convenience-container">
        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/7b9d75e7fcee706ca6a6eeb18ddd293a.jpg" alt="">
        <div class="convenience-content">
          <div class="main-txt">
            <h3 class="tit">EFFICIENCY MEETS CONVENIENCE</h3>
            <h4>One-Touch<br/>Dual-Waterway Cleaning</h4>
            <p class="desc">One-touch auto cleaning for both ultrasonic and airstream waterways<br/>
              Two cleaning durations optional: 120s, 20s<br/>
              Saves time and ensures the device is ready for the next procedure</p>
          </div>
          <div class="params">
            <p>120s</p>
            <p>20s</p>
          </div>

          <div class="powder-container">
            <h4>IlluminatedPowder Container</h4>
            <p class="desc">LED-lit powder container makes it easier to differentiate between powders, <br/>
              streamlining clinical operations:</p>
            <div class="clinical-operations">
              <div class="clinical-operation">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/832ca59684967b90e3c46046a3610085.jpg" alt="">
                <p>Green light: erythritol/glycine powder</p>
              </div>
              <div class="clinical-operation">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/9af36e72785205340f175ba6b58b47cd.jpg" alt="">
                <p>White light: sodium bicarbonate powder</p>
              </div>
            </div>
          </div>
        </div>
        <div class="upgraded">
          <div class="upgraded-container">
            <div class="before">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/449659911758de3321aefb88616520d5.png" alt="">
              <p>PT-E</p>
            </div>
            <div class="after">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/9bddd7c1c3ed0ee954d42e3963799a61.png" alt="">
              <p>Standard</p>
            </div>
            <div class="ps">
              <h4>Pinch Valve<br/>
                Upgraded to<br/>
                Ceramic Valve</h4>
              <p class="desc">Lower risk of tube rupture<br/>
                Greater operational stability.</p>
            </div>
          </div>
          <div class="glow"></div>
        </div>
      </div>

      <div class="intelligent-interface">
        <div class="intelligent-interface-container">
          <div class="interface-info">
            <h4>Adaptive Intelligent<br/>Interface</h4>
            <p class="desc">The interface supports up to 15 languages and<br/>
              features 3 adjustable screen brightness levels,<br/>
              making it adaptable to various clinical environments.</p>
            <div class="screen-img">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/e8dd97347a511be4c46b31627c404e1b.png" alt="">
            </div>
          </div>
          <div class="language-img">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/2cee6162e2ea5510e48e171fd4513cfd.png" alt="">
          </div>
        </div>
      </div>

      <div class="dental-cart-container">
        <div class="dental-cart-info">
          <h4>Mobile<br/>
            Dental Cart</h4>
          <p class="desc">Neatly stores external tubing<br/>and cables fora clutter-free<br/>workspace, making your<br/>device readily accessible.</p>
        </div>
        <div class="dental-cart-img">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260705/5e345d353080658dbb60cd6be0f6be7e.png" alt="">
        </div>
      </div>

      <div class="maintenance-reminder-container">
        <div class="maintenance-reminder-info">
          <h4>Smart Maintenance<br/>
            Reminder</h4>
          <p class="desc">Monitors usage and alerts you for airstream cord or<br/>
            powder container maintenance, ensuring optimal<br/>
            performance for seamless workflows</p>
        </div>
        <div class="maintenance-reminder-img">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260705/82374ed4f47f5e7d68a5121a8f10ad6b.png" alt="">
        </div>
        <div class="glow"></div>
      </div>
      
      <div class="accessories-container">
        <div class="accessories-content">
          <p>Accessories</p>
          <div class="accessories-img">
            <div class="txt">
              <div>
                <p>Periodontal<br/>
                  treatment<br/>
                  handpiece</p>
                <p>31.08.01.009</p>
              </div>
              <div>
                <p>Airstreaming<br/>supragingival<br/>handpiece</p>
                <p>31.16.20.086-002</p>
              </div>
              <div>
                <p>Airstreaming<br/>supragingival<br/>handpiece</p>
                <p>31.16.20.087</p>
              </div>
              <div>
                <p>Wireless<br/>multi-function<br/>foot pedal</p>
                <p>31.16.06.153</p>
              </div>

              <div>
                <p>lluminated powder<br/>
                  container<br/>
                  (Sodium bicarbonate)</p>
                <p>31.16.06.216-008</p>
              </div>

              <div>
                <p>Illuminated powder<br/>container<br/>
                  (Erythritol/Glycine)</p>
                <p>31.16.06.219-008</p>
              </div>

              <div>
                <p>O-ring kit</p>
                <p>31.16.06.241</p>
              </div>
            </div>
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260705/fc499476ae1c5e9aa08bab774652f9d2.png" alt="">
          </div>

          <div class="parameters-content">
            <p class="tit">parameters</p>
            <p class="txt">
              Output main vibration offset of tip (maximum): 90um; deviation: +50%<br/>Output vibrating frequency of tip: 30+5kHz<br/>
              Output semi-offset force: 10N; deviation: +50%<br/>
              Output power of tip: 3W ~ 20w<br/>
            </p>
          </div>
        </div>

      </div>
    </div>

    <video-modal ref="videoModalRef"></video-modal>

  </div>

</template>

<script>
import circularProgress from "../components/progress-circle.vue";
import videoModal from '../components/video-modal.vue'

import viewButton from './components/button.vue'

export default {
  name: 'pt-e',
  components: {
    circularProgress,
    videoModal,
    viewButton
  },
  data(){
    return {
      videoList: [
        {
          ref: 'promotionalRef',
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/211673ce5001834809790398618/po3helZwStsA.mp4',
          progress: 0,
          playing: false,
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/9b55febd5001834811219738812/aQt6lMdI7RgA.mp4',
          hasEntered: false,
          hasLeft: false
        }
      ],
    }
  },
  mounted() {

  },
  methods: {
    handleVisibility(isVisible, index) {
      const ref = this.videoList[index].ref;
      if (isVisible && !this.videoList[index].hasEntered) {
        this.$refs[ref].play().catch(e => console.log(ref + "视频播放失败:", e));
        this.videoList[index].playing = true
        this.videoList[index].hasEntered = true
        this.videoList[index].hasLeft = false
      } else if (!isVisible && !this.videoList[index].hasLeft) {
        this.$refs[ref].pause()
        this.videoList[index].playing = false
        this.videoList[index].hasLeft = true
        this.videoList[index].hasEntered = false
      }
    },
    togglePlay(index) {
      const ref = this.videoList[index].ref;
      this.videoList[index].playing = !this.videoList[index].playing;
      if(this.videoList[index].playing){
        this.$refs[ref].play().catch(e => console.log(ref + "视频播放失败:", e));
      }else {
        this.$refs[ref].pause();
      }
    },
    openVideoModal(url){
      this.$refs.videoModalRef.open(url)
    },
  }
};
</script>

<style>
h1, h2, h3, h4, h5, h6, p {
  padding: 0;
  margin: 0;
}

.pt-e-detail h1, .pt-e-detail h2, .pt-e-detail h3 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 20px;
  color: #1B1B1B ;
}

.pt-e-detail h4, .pt-e-detail h5, .pt-e-detail h6 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 20px;
  color: #1B1B1B ;
}
.pt-e-detail p {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 20px;
  color: #7d7d7d ;
  margin: 0;
  padding: 0;
}
.pt-e-detail {
  position: relative;
}
.pt-e-detail img {
  display: block;
  width: 100%;
}
.pt-e-detail .pt-e-banner {
  position: relative;
  width: 100%;
  height: 100%;
}
.pt-e-detail .pt-e-banner .pt-e-banner-txt {
  width: 100%;
  position: absolute;
  top: 135px;
}
.pt-e-detail .pt-e-banner .pt-e-banner-txt p {
  color: #ffffff;
  font-size: 26px;
  text-align: center;
  margin-top: 37px;
}
.pt-e-detail .pt-e-banner  .pt-e-banner-txt .p-title {
  width: 270px;
  margin: 0 auto;
}
.pt-e-detail .pt-e-banner .pt-e-banner-img {}
.pt-e-detail .pt-e-banner .pt-e-banner-img img {

}

.pt-e-detail .promotional-cover {
  position: relative;

}

.pt-e-detail .promotional-cover .background-video {
  width: 100%;
  height: 100vh;
  object-fit: cover;
  display: block;
}
.pt-e-detail .mask {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  z-index: 3;
}

.pt-e-detail .promotional-cover .mask .content {
  margin-top: 288px;
}
.pt-e-detail .promotional-cover .mask .content h3 {
  color: #ffffff;
  text-align: center;
  font-size: 56px;
  line-height: 108px;
}
.pt-e-detail .promotional-cover .mask .content .button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 88px;
}
.pt-e-detail .promotional-cover .progress {
  position: absolute;
  right: 40px;
  top: 20px;
  z-index: 5;
}

.pt-e-detail h3 {
  font-size: 80px;
}

.pt-e-detail h4 {
  font-size: 45px;
  margin-bottom: 26px;
}

.pt-e-detail .desc {
  font-size: 18.3px;
  line-height: 1.8;
}

.pt-e-detail .power-container {
  text-align: center;
  padding-bottom: 160px;
}

.pt-e-detail .power-container .tit {
  background: linear-gradient(
      90deg,
      #8000ff 0%,
      #9933ff 39%,
      #b366ff 42%,
      #cc99ff 60%,
      #e6ccff 80%,
      #f5e6ff 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-top: 206px;
  margin-bottom: 149px;

}

.pt-e-detail .power-container .num {
  background: linear-gradient(
      110deg,
      #6000ff 0%,    /* 3的左下角最深 */
      #7d2aff 30%,
      #9a54ff 40%,
      #b77eff 50%,
      #d4a8ff 52%,
      #f1d2ff 100%   /* %的右上角最浅 */
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 72px;
  line-height: 1;
  margin-top: 20px;
}

.pt-e-detail .power-container .model {
  width: 1050px;
  margin: 20px auto 0 auto;
  background: linear-gradient(to bottom, #ffffff, #f5f5fa);
  position: relative;
}
.pt-e-detail .power-container .model p {

}

.pt-e-detail .power-container .model-tit {
  position: absolute;
  top: 184px;
}
.pt-e-detail .power-container .model-tit.previous {
  left: 114px;
}
.pt-e-detail .power-container .model-tit.new {
  right: 168px;
}

.pt-e-detail .feature-container {
  position: relative;
}
.pt-e-detail .feature-container .feature-bg {}
.pt-e-detail .feature-container .feature-content {
  position: absolute;
  top: 153px;
  left: 445px;
}
.pt-e-detail .feature-container .feature-content p{
  color: #ffffff;
  font-size: 16.5px;
  line-height: 1.9;
}
.pt-e-detail .feature-container .feature-content .params {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.pt-e-detail .feature-container .feature-content .params.pt-e-c {
  margin-top: 35px;
}
.pt-e-detail .feature-container .feature-content .params.Standard-c {
  margin-top: 33px;
}

.pt-e-detail .feature-container .feature-content .params div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #dcd4ff;
  padding: 0 12px;
}
.pt-e-detail .feature-container .feature-content .params div p {
  color: #312252!important;
}
.pt-e-detail .feature-container .feature-content .params .pt-e{
  width: 284px;
}
.pt-e-detail .feature-container .feature-content .params .Standard {
  width: 414px;
}
.pt-e-detail .feature-container .feature-content .params .tit {
  margin-left: 20px;
}


.pt-e-detail .heating-system-container {
  text-align: center;
  background: linear-gradient(to bottom, #fefefe, #f6f6fa);
}
.pt-e-detail .heating-system-container h4 {
  margin-top: 82px;
  margin-bottom: 18px;
}

.pt-e-detail .heating-system-container .heating-system-img {
  width: 1030px;
  margin: 38px auto 0 auto;
}
.pt-e-detail .heating-system-container .upgraded {
  display: flex;
  justify-content: flex-start;
  margin-top: 109px;
}
.pt-e-detail .heating-system-container .upgraded .img {
  width: 582px;
  margin-left: 445px;
}
.pt-e-detail .heating-system-container .upgraded h4 {
  margin-top: 0;
  line-height: 0.9;
  font-size: 39px;
}

.pt-e-detail .heating-system-container .upgraded .txt {
  margin-left: 90px;
  margin-top: 150px;

}

.pt-e-detail .heating-system-container .upgraded .txt .desc {
  text-align: left;
  font-size: 13.2px;
  margin-top: 35px;
}

.pt-e-detail .heating-system-container .titanium-alloy {
  margin-top: 136px;
  position: relative;
  padding-top: 10px;
}
.pt-e-detail .heating-system-container .titanium-alloy .txt {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0px;
}
.pt-e-detail .heating-system-container .titanium-alloy .txt h4 {
  margin-top: 12px;
  font-size: 39px;
}
.pt-e-detail .heating-system-container .titanium-alloy .txt p {
  font-size: 16.2px;
  margin-top: 30px;
}


.pt-e-detail .precision-container {
  text-align: center;
}
.pt-e-detail .precision-container .tit {
  background: linear-gradient(
      90deg,
      #8000ff 0%,
      #9933ff 39%,
      #b366ff 50%,
      #cc99ff 75%,
      #c8a4ff 80%,
      #c19bff 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-top: 208px;
  margin-bottom: 145px;
  font-size: 72.5px;
}

.pt-e-detail .precision-container h4 {
  margin-top: 162px;
  margin-bottom: 22px;
}
.pt-e-detail .precision-container .desc {

}

.pt-e-detail .precision-container .step-use {
  display: flex;
  justify-content: center;
  margin-top: 92px;
}

.pt-e-detail .precision-container .step-use .step-item {
  width: 400px;
  margin-left: 14px;
  position: relative;
}
.pt-e-detail .precision-container .step-use .step-item:first-child {
  margin-left: 0;
}
.pt-e-detail .precision-container .step-use .step-item .letter {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 110px;
  color: #f46c62;
  top: -72px;
}

.pt-e-detail .precision-container .step-use .step-item:nth-child(1) .letter {
  position: absolute;
  left: 150px;
  transform: translateX(0);
  font-size: 110px;
  color: #f46c62;
  top: -72px;
}

.pt-e-detail .precision-container .step-use .step-item .explain-c {
  position: absolute;
  top: 172px;
  width: 100%;
}
.pt-e-detail .precision-container .step-use .step-item .explain-b {
  text-align: left;
  display: flex;
  justify-content: flex-start;
}


.pt-e-detail .precision-container .step-use .step-item .explain-c .explain-b .explain-tit {
  font-size: 17px;
  color: #575656;
  margin-bottom: 25px;
}


.pt-e-detail .precision-container .step-use .step-item .explain-c .explain-b p {
  font-size: 13px;
}

.pt-e-detail .precision-container .step-use .step-item:first-child .explain-c .explain-b div:first-child {
  margin-left: 58px;
}
.pt-e-detail .precision-container .step-use .step-item:first-child .explain-c .explain-b div:last-child {
  margin-left: 30px;
}

.pt-e-detail .precision-container .step-use .step-item:nth-child(2) .explain-c .explain-b div:first-child {
  margin-left: 52px;
}
.pt-e-detail .precision-container .step-use .step-item:nth-child(2) .explain-c .explain-b div:last-child {
  margin-left: 58px;
}
.pt-e-detail .precision-container .step-use .step-item:nth-child(2) .explain-c .explain-b div:last-child .explain-tit {
  margin-bottom: 2px;
}


.pt-e-detail .precision-container .step-use .step-item:nth-child(3) .explain-c .explain-b div:first-child {
  margin-left: 32px;
}
.pt-e-detail .precision-container .step-use .step-item:nth-child(3) .explain-c .explain-b div:last-child {
  margin-left: 26px;
}

.pt-e-detail .precision-container .scaling {
  width: 1228px;
  margin: 30px auto 138px auto;
}


.pt-e-detail .convenience-container {
  position: relative;
}

.pt-e-detail .convenience-container .convenience-content h4 {
  color: #ffffff;
}
.pt-e-detail .convenience-container .convenience-content p {
  color: #ffffff;
}
.pt-e-detail .convenience-container .convenience-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

.pt-e-detail .convenience-container .convenience-content .tit {
  background: linear-gradient(
      90deg,
      #dfcfff 0%,
      #baa3e7 39%,
      #a88edb 50%,
      #977ad1 75%,
      #8a6bc8 80%,
      #7f5dc1 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.pt-e-detail .convenience-container .convenience-content {

}

.pt-e-detail .convenience-container .convenience-content .main-txt {
  text-align: center;
  margin-top: 186px;
}

.pt-e-detail .convenience-container .convenience-content .main-txt h4 {
  margin-top: 60px;
  margin-bottom: 20px;
}

.pt-e-detail .convenience-container .convenience-content .main-txt .desc {
  line-height: 1.6;
}
.pt-e-detail .convenience-container .convenience-content .params {
  margin-left: 593px;
  margin-top: 97px;
}
.pt-e-detail .convenience-container .convenience-content .params p {
  color: #ffffff;
  font-size: 65px;

}

.pt-e-detail .convenience-container .convenience-content .params p:last-child {
  margin-top: 68px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container {
  text-align: center;
  margin-top: 425px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container .desc {
  margin-top: 30px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container .clinical-operations {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container .clinical-operations .clinical-operation {
  width: 498px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container .clinical-operations .clinical-operation p {
  margin-top: 16px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container .clinical-operations .clinical-operation:last-child {
  margin-left: 50px;
}

.pt-e-detail .convenience-container .upgraded{
  background-color: #000000;
  padding-top: 70px;
  padding-bottom: 70px;
  position: relative;
  overflow: hidden;
}
.pt-e-detail .convenience-container .upgraded .upgraded-container{
  display: flex;
  padding-left: 440px;
  position: relative;
  z-index: 2;
}

.pt-e-detail .convenience-container .upgraded .upgraded-container .before,
.pt-e-detail .convenience-container .upgraded .upgraded-container .after {
  width: 260px;
  text-align: center;
}

.pt-e-detail .convenience-container .upgraded .upgraded-container .before p,
.pt-e-detail .convenience-container .upgraded .upgraded-container .after p {
  margin-top: 20px;
}

.pt-e-detail .convenience-container .upgraded .upgraded-container .after {
  margin-left: 91px;
}

.pt-e-detail .convenience-container .upgraded .upgraded-container .ps {
  margin-left: 63px;
  margin-top: 105px;
}
.pt-e-detail .convenience-container .upgraded .upgraded-container .before p,
.pt-e-detail .convenience-container .upgraded .upgraded-container .after p,
.pt-e-detail .convenience-container .upgraded .upgraded-container .ps p,
.pt-e-detail .convenience-container .upgraded .upgraded-container .ps h4 {
  color: #ffffff;
}

.pt-e-detail .convenience-container .upgraded .upgraded-container .ps h4 {
  line-height: 1.3;
}

.pt-e-detail .convenience-container .upgraded .glow {
  position: absolute;
  width: 2000px;
  height: 1600px;
  bottom: -850px;
  border-radius: 50%;
  left: 50%;
  transform: translateX(-50%);
  //background: rgba(84,67,118,0.7);
  //z-index: 1;
  background: radial-gradient(circle at center, rgba(87, 69, 122,.6) 20%, transparent 60%), #000000;
}

.pt-e-detail .intelligent-interface {
  background: linear-gradient(
      180deg,
      #000000 0%,
      #0a0615 70%,
      #150b28 95%,
      #1a0f30 100%
  );
  padding-left: 446px;
  padding-bottom: 115px;

}
.pt-e-detail .intelligent-interface .intelligent-interface-container {
  display: flex;
  justify-content: flex-start;
}

.pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info {
}
.pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info h4,
.pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info p {
  color: #ffffff;
}

.pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info h4 {
  padding-top: 195px;
  margin-bottom: 45px;
}
.pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info p {
  font-size: 19px;
  line-height: 1.8;
}
.pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info .screen-img {
  width: 360px;
  margin-top: 120px;
}

.pt-e-detail .intelligent-interface .intelligent-interface-container .language-img {
  width: 358px;
  margin-top: 130px;
  margin-left: 150px;
}


.pt-e-detail .dental-cart-container {
  background-color: #000000;
  padding-top: 130px;
  position: relative;
}

.pt-e-detail .dental-cart-container .dental-cart-img {
  width: 1030px;
  margin: 0 auto 0 auto;
  background: linear-gradient(
      180deg,
      #000000 0%,
      #0a0615 70%,
      #150b28 95%,
      #1a0f30 100%
  );
}

.pt-e-detail .dental-cart-container .dental-cart-info {
  position: absolute;
  left: 835px;
  top: 115px;
  text-align: center;
}
.pt-e-detail .dental-cart-container .dental-cart-info h4 {
  color: #ffffff;
  margin-bottom: 12px;
}
.pt-e-detail .dental-cart-container .dental-cart-info p {
  color: #ffffff;
  line-height: 1.6;
}


.pt-e-detail .maintenance-reminder-container {

  background-color: #000000;
  padding-top: 30px;
  position: relative;
  overflow: hidden;
}

.pt-e-detail .maintenance-reminder-container .maintenance-reminder-info {
  position: absolute;
  left: 740px;
  top: 170px;
  text-align: center;
  z-index: 3;
}

.pt-e-detail .maintenance-reminder-container .maintenance-reminder-img {
  position: relative;
  z-index: 3;
}
.pt-e-detail .maintenance-reminder-container .maintenance-reminder-info h4 {
  color: #ffffff;
  margin-bottom: 19px;
}
.pt-e-detail .maintenance-reminder-container .maintenance-reminder-info p {
  color: #ffffff;
}

.pt-e-detail .maintenance-reminder-container .glow {
  position: absolute;
  width: 3000px;
  height: 2000px;
  bottom: -1200px;
  border-radius: 50%;
  left: 850px;
  transform: translateX(-50%);
  //background: rgba(84,67,118,0.7);
  //z-index: 1;
  background: radial-gradient(circle at center, rgba(87, 69, 122,.6) 20%, transparent 60%), #000000;
  z-index: 2;
}



.pt-e-detail .accessories-container {
  background-color: #000000;

}

.pt-e-detail .accessories-container .accessories-content {
  padding-top: 92px;
}

.pt-e-detail .accessories-container .accessories-content p {
  color: #ffffff;
  font-size: 28px;
}

.pt-e-detail .accessories-container {
  padding-bottom: 160px;
}
.pt-e-detail .accessories-container .accessories-content {
  width: 1025px;
  margin: 0 auto 0 auto;
}
.pt-e-detail .accessories-container .accessories-content .accessories-img {
  margin-top: 60px;
  position: relative;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div {
  padding: 33px 0 0 117px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(2){
  padding-left: 138px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(3){
  padding-left: 132px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(4){
  padding-left: 209px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(5){
  padding-top: 102px;
  padding-left: 118px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(6){
  padding-top: 102px;
  padding-left: 160px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(7){
  padding-top: 116px;
  padding-left: 333px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div p {
  font-size: 14px;
  color: #b3b3b3;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div p:nth-child(2){
  margin-top: 16px;
}

.pt-e-detail .accessories-container .accessories-content .parameters-content {
  margin-top: 93px;
}

.pt-e-detail .accessories-container .accessories-content .parameters-content .tit {}
.pt-e-detail .accessories-container .accessories-content .parameters-content .txt {
  margin-top: 35px;
  font-size: 14px;
  line-height: 1.7;
}

</style>